import React from "react";

import axios from "axios";

const checkValidityOfMachine = async () => {

    let current_machineguid = JSON.parse(localStorage.getItem("current_machineguid"));
    let apiUrl;

    if (current_machineguid) {

        apiUrl = `${process.env.REACT_APP_BASE_URL}/ValidMachine/${current_machineguid.machineguid}`;

        // console.log("inside validate Machine apiUrl ", apiUrl);

        let resultToReturn = await axios
            .get(apiUrl)
            .then((res) => {

                if (res.data.length > 0) {

                    console.log("Yess valid Machine, show login");
                   
                    return true;

                   //return false
                    

                } else {

                    console.log("machine not validated, Register machine");
                    return false;
                }

            })
            .catch((e) => {

                console.log("Eror while validating machine ", e);
                return null
            });

        console.log("resultToReturn --> ", resultToReturn)

        return resultToReturn;

    }
    else {

        return false
    }

}

export { checkValidityOfMachine };